import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Timer } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";

const RAFFLE_IMG = "https://customer-assets.emergentagent.com/job_exfoliating-bars/artifacts/hqjk1cgk_file_00000000654471f59bbc68672c6e6697.png";

export default function RaffleBanner() {
  const [countdown, setCountdown] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const navigate = useNavigate();

  useEffect(() => {
    const target = new Date("2026-07-01T00:00:00Z");
    const update = () => {
      const diff = target - new Date();
      if (diff <= 0) {
        setCountdown({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }
      setCountdown({
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((diff / (1000 * 60)) % 60),
        seconds: Math.floor((diff / 1000) % 60),
      });
    };
    update();
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section id="raffle-banner" className="py-16 lg:py-20" data-testid="raffle-banner-landing">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        {/* Raffle Image */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="overflow-hidden border cursor-pointer mb-8"
          style={{ borderColor: '#FF5A36' }}
          onClick={() => navigate("/raffle")}
        >
          <img
            src={RAFFLE_IMG}
            alt="Win Free Soap for a Year - Every bar you buy = 1 raffle entry"
            className="w-full object-contain"
            data-testid="raffle-landing-image"
          />
        </motion.div>

        {/* Countdown */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="p-8 border text-center"
          style={{ borderColor: '#2A2A2A', backgroundColor: '#141414' }}
          data-testid="landing-countdown-timer"
        >
          <div className="flex items-center justify-center gap-2 mb-4">
            <Timer size={22} weight="bold" style={{ color: '#FF5A36' }} />
            <p className="font-accent text-sm tracking-[0.2em] uppercase font-semibold" style={{ color: '#FF5A36' }}>
              Drawing Countdown
            </p>
          </div>
          <div className="grid grid-cols-4 gap-6 max-w-md mx-auto mb-5">
            <div>
              <p className="font-heading text-4xl sm:text-5xl font-light" style={{ color: '#F0EDE5' }}>{countdown.days}</p>
              <p className="font-accent text-xs uppercase mt-1" style={{ color: '#666' }}>Days</p>
            </div>
            <div>
              <p className="font-heading text-4xl sm:text-5xl font-light" style={{ color: '#F0EDE5' }}>{countdown.hours}</p>
              <p className="font-accent text-xs uppercase mt-1" style={{ color: '#666' }}>Hours</p>
            </div>
            <div>
              <p className="font-heading text-4xl sm:text-5xl font-light" style={{ color: '#F0EDE5' }}>{countdown.minutes}</p>
              <p className="font-accent text-xs uppercase mt-1" style={{ color: '#666' }}>Min</p>
            </div>
            <div>
              <p className="font-heading text-4xl sm:text-5xl font-light" style={{ color: '#F0EDE5' }}>{countdown.seconds}</p>
              <p className="font-accent text-xs uppercase mt-1" style={{ color: '#666' }}>Sec</p>
            </div>
          </div>
          <p className="font-body text-sm mb-5" style={{ color: '#9A9A9A' }}>
            Drawing July 1st, 2026 or first 500 entries — every bar = 1 entry!
          </p>
          <button
            onClick={() => navigate("/raffle")}
            className="inline-flex items-center gap-2 px-8 py-3 text-sm font-accent font-semibold tracking-wider uppercase text-white transition-all hover:brightness-110"
            style={{ backgroundColor: '#FF5A36' }}
            data-testid="enter-raffle-btn"
          >
            Enter the Raffle
          </button>
        </motion.div>
      </div>
    </section>
  );
}
